import wx from 'weixin-js-sdk'
import * as ww from '@wecom/jssdk'
import store from '@/store'
import { deviceType } from './common'
import { ROOT_COMPANY_ID } from '@/constant/company'

let hasFinishedConfig = false
let hasReady = false

async function initWxSDK (url) {
  if (hasFinishedConfig) {
    return
  }
  if (!url.startsWith('http')) {
    url = window.location.origin + url
  }

  const resp = await store.dispatch('common/getWxApiTicket', url)
  if (resp.status !== 'success') {
    return
  }

  wx.config({
    debug: false,
    appId: resp.data.app_id,
    timestamp: resp.data.timestamp,
    nonceStr: resp.data.nonceStr,
    signature: resp.data.signature,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareQZone',
      'updateAppMessageShareData',
      'updateTimelineShareData'
    ]
  })
  hasFinishedConfig = true
}
/**
  * job detail page, company detail page, company job list page need referral wechat share
  */
async function configWxShare (vm, jobId, rootCompanyId, companyId) {
  if (!deviceType.isWeChat) {
    return
  }
  if (deviceType.isWeChatWork) {
    return
  }
  const wxShareInfo = vm.wxShareInfo
  const url = vm.$DjangoBaseUrl(vm.$route.fullPath).split('#')[0]
  initWxSDK(url)

  wxShareInfo.image_url = window.location.origin + wxShareInfo.logo
  wxShareInfo.link = wxShareInfo.normal_share_url || window.location.href

  setWxShare(wxShareInfo, jobId, rootCompanyId, companyId)
}

function getShareParam (wxShareInfo, shareTo, useMomentTitle, jobId) {
  if (wxShareInfo.page_type === 'JobDetail') {
    wxShareInfo.link = wxShareInfo.normal_share_url || window.location.href
  }
  const params = {
    title: useMomentTitle ? wxShareInfo.moment_title : wxShareInfo.title,
    desc: wxShareInfo.description,
    link: wxShareInfo.link,
    imgUrl: wxShareInfo.image_url,
    success: function () {
      // store.dispatch('common/trackWeChatShare', {
      //   share_to: shareTo,
      //   link: wxShareInfo.link,
      //   location: window.location.href,
      //   job_id: jobId
      // })
      // if (wxShareInfo.success) {
      //   wxShareInfo.success()
      // }
    }
  }

  return params
}

export async function configWxShareOnMicroSite (appMessageShareData, timelineShareData, rootCompanyId) {
  const url = window.location.href.split('#')[0]
  await initWxSDK(url)
  updateShareData(appMessageShareData, timelineShareData, rootCompanyId)
}

export function updateShareData (appMessageShareData, timelineShareData, rootCompanyId) {
  if (hasReady) {
    wx.updateAppMessageShareData(appMessageShareData)
    wx.updateTimelineShareData(timelineShareData)

    if (rootCompanyId === ROOT_COMPANY_ID.COACH) {
      configCoachMiniProgramShare(appMessageShareData.title, appMessageShareData.desc, appMessageShareData.imgUrl, appMessageShareData.link)
    }
  } else {
    wx.ready(() => {
      hasReady = true
      wx.updateAppMessageShareData(appMessageShareData)
      wx.updateTimelineShareData(timelineShareData)

      if (rootCompanyId === ROOT_COMPANY_ID.COACH) {
        configCoachMiniProgramShare(appMessageShareData.title, appMessageShareData.desc, appMessageShareData.imgUrl, appMessageShareData.link)
      }
    })
  }
}
/**
 * 配置Coach小程序的分享功能
 * @param {*} title 分享的卡片的标题
 * @param {*} desc 分享的卡片的描述
 * @param {*} imageUrl 分享的卡片的图片
 * @param {*} link 分享的卡片打开后 webview 里页面的链接
 */
export function configCoachMiniProgramShare (title, desc, imageUrl, link) {
  wx.miniProgram.postMessage({
    data: {
      type: 'share', // 类型
      title: title,
      desc: desc,
      imageUrl: imageUrl,
      path: `pages/webview/detail?wa_ext_field=${encodeURIComponent(JSON.stringify({
        detailUrl: link
      }))}`
    }
  })
}
/**
 * 配置小程序分享功能，目前只有 Coach 能使用
 * @param {*} wxShareInfo
 * @param {*} jobId
 * @param {*} rootCompanyId
 * @param {*} companyId
 */
export function configMiniProgramShare (wxShareInfo, jobId, rootCompanyId, companyId) {
  if (rootCompanyId !== ROOT_COMPANY_ID.COACH) {
    return
  }
  const shareParam = getShareParam(wxShareInfo, 'wechat_app_message', false, jobId)
  configCoachMiniProgramShare(shareParam.title, shareParam.desc, shareParam.imgUrl, shareParam.link)
}

export function setWxShare (wxShareInfo, jobId, rootCompanyId, companyId) {
  wxShareInfo.moment_title = wxShareInfo.moment_title.replace(/&#39;/g, "'")
  wxShareInfo.title = wxShareInfo.title.replace(/&#39;/g, "'")
  if (hasReady) {
    wx.updateAppMessageShareData(getShareParam(wxShareInfo, 'wechat_app_message', false, jobId))
    wx.updateTimelineShareData(getShareParam(wxShareInfo, 'wechat_timeline', true, jobId))
    // 配置小程序分享
    configMiniProgramShare(wxShareInfo, jobId, rootCompanyId, companyId)
  } else {
    wx.ready(() => {
      hasReady = true
      wx.updateAppMessageShareData(getShareParam(wxShareInfo, 'wechat_app_message', false, jobId))
      wx.updateTimelineShareData(getShareParam(wxShareInfo, 'wechat_timeline', true, jobId))
      // 配置小程序分享
      configMiniProgramShare(wxShareInfo, jobId, rootCompanyId, companyId)
    })
  }
}

export function refreshShareParam (shareInfo, link, jobId, rootCompanyId, companyId) {
  shareInfo.link = link || window.location.href
  setWxShare(shareInfo, jobId, rootCompanyId, companyId)
}

export function configWeComShare (weComAppInfo, wxShareInfo) {
  if (!weComAppInfo) {
    return
  }
  const corpId = weComAppInfo.corp_id
  ww.register({
    // 必填，当前用户企业所属企业ID
    corpId: corpId,
    // 必填，需要使用的JS API列表
    jsApiList: ['onMenuShareAppMessage', 'onMenuShareWechat', 'onMenuShareTimeline'],
    // 必填，根据url生成企业签名的回调函数
    getConfigSignature: (url) => store.dispatch('common/getWeComApiTicket', { url, weComAppId: weComAppInfo.id }).then(resp => ({
      timestamp: resp.timestamp,
      nonceStr: resp.nonceStr,
      signature: resp.signature
    }))
  })

  if (wxShareInfo) {
    // 「转发」按钮点击
    ww.onMenuShareAppMessage(getShareParam(wxShareInfo, 'wecom_app_message'))

    // 「微信」按钮点击
    ww.onMenuShareWechat(getShareParam(wxShareInfo, 'wechat_app_message'))

    // 「朋友圈」按钮点击
    ww.onMenuShareTimeline(getShareParam(wxShareInfo, 'wechat_timeline', true))
  }
}

export default configWxShare
